import { faUsers } from '@fortawesome/pro-light-svg-icons';
import { IconDefinition } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';

import classes from './NoAvailability.module.scss';

interface NoAvailabilityProps {
    icon?: IconDefinition;
    description?: string;
}

export const NoAvailability: React.FC<NoAvailabilityProps> = ({
    icon = faUsers,
    description = 'No staff available for all selected services. Check availability for one pet or contact the business for assistance.'
}) => {
    return (
        <div className={classes.root}>
            <div className={classes.icon}>
                <FontAwesomeIcon icon={icon} />
            </div>

            <p className={classes.title}>No Availability</p>
            <p>{description}</p>
        </div>
    );
};
